import Vue from "vue";
import VueRouter from "vue-router";
import LandingLayout from "@/components/layouts/LandingLayout.vue";
import MainLayout from "@/components/layouts/MainLayout.vue";
import { auth } from '@/firebase'
import store from '@/store'
import { ERROR } from '@/store/actions.type'

Vue.use(VueRouter);

const routes = [
  {
    path: '/', //process.env.BASE_URL
    component: LandingLayout,
    meta: {
      title: "Home",
      requiresAuth: false,
      roles: [],
      heading: "",
      hidden: false,
      divider: false,
      icon: "home"
    },
    children: [
      {
        path: "",
        name: "Introduction",
        component: () => import("@/views/Home.vue"),
        meta: {
          requiresAuth: false,
          roles: [],
          heading: "",
          hidden: false,
          divider: false,
          icon: "home"
        }
      }
    ]
  },
  {
    path: "/init",
    component: MainLayout,
    meta: {
      title: "Init",
      requiresAuth: true,
      roles: [],
      heading: "",
      hidden: true,
      divider: false,
      icon: "home"
    },
    children: [
      {
        path: '',
        name: 'Init',
        component: () => import("@/views/Init.vue"),
      }
    ]
  },
  {
    path: "/users",
    component: MainLayout,
    meta: {
      title: "User's Profile",
      requiresAuth: true,
      roles: [],
      heading: "",
      hidden: true,
      divider: false,
      icon: "home"
    },
    children: [
      {
        path: '',
        name: "Users"
      },
      {
        path: "/users/:username",
        name: "User's Profile",
        meta: {
          requiresAuth: false,
          roles: [],
          heading: "Profile",
          hidden: false,
          divider: true,
          icon: "login"
        },
        component: () => import("@/components/users/Update.vue")
        , props: true
      },
      // {
      //   path: "/users/update",
      //   name: "Update User",
      //   meta: {
      //     requiresAuth: true,
      //     roles: [],
      //     heading: "Update Profile",
      //     hidden: false,
      //     divider: true,
      //     icon: "security"
      //   },
      //   component: () =>
      //     import("@/components/users/Update.vue")
      // }
    ]
  },
  {
    path: "/login",
    component: LandingLayout,
    meta: {
      title: "Login",
      requiresAuth: false,
      roles: [],
      heading: "Auth",
      hidden: true,
      divider: true,
      icon: "login"
    },
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("@/views/Login.vue")
      }
    ]
  },
  {
    path: "/desk",
    component: MainLayout,
    meta: {
      title: "Desk",
      requiresAuth: true,
      roles: [],
      heading: "TRADE",
      hidden: false,
      divider: true,
      icon: "dashboard"
    },
    children: [
      {
        path: '',
        name: 'Trading Desk',
        roles: [],
        component: () => import("@/views/Commands.vue"),
      }
    ]
  },
  {
    path: "/accounts",
    component: MainLayout,
    meta: {
      title: "Accounts",
      requiresAuth: true,
      roles: [],
      heading: "",
      hidden: false,
      divider: false,
      icon: "attach_money"
    },
    param: true,
    children: [
      {
        path: "",
        name: "Accounts",
        component: () => import("@/views/Accounts.vue")
      },
      // {
      //   path: "/accounts/new",
      //   name: "Account",
      //   component: () => import("@/components/accounts/NewInSteps.vue"),
      //   props: true
      // }
      {
        path: ":id",
        name: "Account",
        component: () => import("@/views/Account.vue"),
        props: true
      }
    ]
  },
  {
    path: "/strategies",
    component: MainLayout,
    meta: {
      title: "Strategy",
      requiresAuth: true,
      roles: [],
      heading: "",
      hidden: false,
      divider: false,
      icon: "insert_chart_outlined"
    },
    children: [
      {
        path: '',
        name: 'All Strategies',
        component: () => import("@/views/Strategies.vue"),
      }
    ]
  },
  {
    path: "/subscriptions",
    component: MainLayout,
    meta: {
      title: "Subscriptions",
      requiresAuth: true,
      roles: [],
      heading: "",
      hidden: false,
      divider: false,
      icon: "flip"
    },
    children: [
      {
        path: '',
        name: 'Subscriptions',
        component: () => import("@/views/Subscriptions.vue")
      }
    ]
  },
  {
    path: "/terminals",
    component: MainLayout,
    meta: {
      title: "Terminal",
      requiresAuth: true,
      roles: [],
      heading: "",
      hidden: false,
      divider: false,
      icon: "code"
    },
    children: [
      {
        path: '',
        name: 'All Terminals',
        component: () => import("@/views/Terminals.vue")
      }
    ]
  },

  {
    path: "/traders",
    component: MainLayout,
    meta: {
      title: "Traders",
      requiresAuth: true,
      roles: [],
      icon: "trending_up",
      heading: "INVEST",
      divider: true
    },
    children: [
      {
        path: '',
        name: 'All Trader',
        component: () => import("@/views/Traders.vue"),
      }
    ]
  },
  {
    path: "/prices",
    component: MainLayout,
    meta: {
      title: "Price Plans",
      requiresAuth: false,
      roles: [],
      icon: "trending_up",
      heading: "UPGRADE",
      divider: true
    },
    children: [
      {
        path: '',
        name: 'Plans',
        component: () => import("@/components/products/Prices.vue"),
      }
    ]
  },
  {
    path: "/admin",
    component: MainLayout,
    meta: {
      title: "Admins",
      requiresAuth: true,
      roles: ['admin'],
      icon: "trending_up",
      heading: "ADMIN",
      divider: true
    },
    children: [
      {
        path: '',
        name: 'Mange Price',
        component: () => import("@/views/Admin.vue"),
        roles: ['admin'],
      }

    ]
  },
  {
    path: "/brokers",
    component: MainLayout,
    meta: {
      title: "Support Brokers",
      requiresAuth: false,
      roles: [],
      icon: "",
      heading: "",
      divider: true,
      hidden: true
    },
    children: [
      {
        path: '',
        name: 'Brokers',
        component: () => import("@/components/brokers/Brokers.vue"),
        roles: [],
      },
      {
        path: 'auth/:type',
        name: 'Authorize Broker',
        requiresAuth: false,
        component: () => import("@/components/brokers/Ctrader.vue"),
        roles: [],
      }
    ]
  },
  {
    path: "/error",
    component: LandingLayout,
    meta: {
      title: "Errors",
      requiresAuth: false,
      roles: [],
      icon: "",
      heading: "",
      divider: true,
      hidden: true
    },
    children: [
      {
        path: '',
        name: 'Error',
        component: () => import("@/views/Error.vue"),
        roles: [],
      }

    ]
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const credential = auth.onAuthStateChanged(user => { return user })
  document.title = to.name ? "TradingIF.com / " + to.name : "TradingIF.com";
  function rolesCheck() {
    // get roles from user
    let currentUser = store.getters.currentUser
    let userRoles = currentUser ? currentUser.roles : []
    // get roles from route meta
    let requiredRoles = to.matched.find(record => record.meta.roles).meta.roles
    if (requiredRoles && requiredRoles.length > 0) {
      return requiredRoles.some(role => userRoles.includes(role))
    } else {
      return true
    }
  }
  if (rolesCheck()) {
    if (requiresAuth && !credential) {
      store.dispatch(ERROR.SET, 'Require role: ' + store.getters.currentUser.roles)
      next('/auth')
    } else {
      next()
    }
  } else {
    next('/auth')
  }
})
export default router;
